<template>
  <page :title="$tc('magazine')+' / '+$tc('magazines.categories')">
    <div slot="page-header-right">
      <router-link :to="`/magazine/categories/add`">
        <button class="button is-primary">
          <b-icon icon="plus"></b-icon>
          <span>
            <slot>Add Category</slot>
          </span>
        </button>
      </router-link>
    </div>
    <div class="box">
      <b-table
        class="is-middle"
        :loading="categories.loading"
        paginated
        backend-pagination
        pagination-position="bottom"
        :data="categories.data"
        :current-page="categories.current_page"
        :per-page="categories.per_page"
        :total="categories.total"
        @page-change="(page) => categories.changePage(page)"
        backend-sorting
        @sort="(field, direction) => categories.sort(field, direction)"
        :default-sort="['id', 'asc']"
      >
        <template slot-scope="{ row: category }">
          <b-table-column :label="$tc('dropdown.category')" field="title" sortable>{{ category.title }}</b-table-column>
          <b-table-column :label="$tc('magazines.magazines')" field="magazines_count" sortable>
            {{ category.magazines_count }}
          </b-table-column>
          <b-table-column :label="$tc('issue')" field="issues_count" sortable>{{
              category.issues_count
            }}
          </b-table-column>
          <b-table-column>
            <div class="is-pulled-right">

              <links-dropdown
                :links="[
                  {
                    label: 'Deep Link',
                    url:
                      `${dl}://q?type=listing&key=category-${category.id}&title=` +
                      encodeURI(category.title),
                  },
                ]"
              ></links-dropdown>
              <router-link
                class="button ml-2"
                :to="`/magazine/categories/${category.id}/edit`"
              >{{ $tc('edit') }}
              </router-link
              >
            </div>
          </b-table-column>
        </template>
      </b-table>
    </div>
  </page>
</template>

<script>
export default {
  data() {
    return {
      dl: this.$store.state.config.app.dl,
      query: localStorage.getItem('categories-search') || '',
      categories: new window.PaginatedRemoteCollection(
        "/admin/api/magazine/categories?include=pages_count"
      ),
    };
  },

  created() {
    this.categories.load();
  },
  methods: {
    searchChanged() {
      localStorage.setItem('categories-search', this.query);
    }
  }

};
</script>
